import DashboardApiTableShow, {DashboardColumn} from './DashboardApiTableShow'
import {SalesRankChangeItem} from './dashboardTableTypes'
import {
  renderDashboardDateTwoLine,
  renderDashboardSku,
} from './dashboardFormatters'

const columns: DashboardColumn<SalesRankChangeItem>[] = [
  {header: 'SKU', sortKey: 'sku', render: (item) => renderDashboardSku(item.sku)},
  {header: 'Channel', sortKey: 'channel', render: (item) => item.channel ?? '-'},
  {header: 'Type', sortKey: 'type', render: (item) => item.type ?? '-'},
  {header: 'Category', sortKey: 'classification_sales_ranks_category', render: (item) => item.classification_sales_ranks_category ?? '-'},
  {header: 'Old Rank', sortKey: 'old_classification_sales_ranks', render: (item) => item.old_classification_sales_ranks ?? '-'},
  {header: 'New Rank', sortKey: 'new_classification_sales_ranks', render: (item) => item.new_classification_sales_ranks ?? '-'},
  {header: 'Display Group', sortKey: 'displaygroup_sales_ranks_category', render: (item) => item.displaygroup_sales_ranks_category ?? '-'},
  {header: 'Old Display Rank', sortKey: 'old_displaygroup_sales_ranks', render: (item) => item.old_displaygroup_sales_ranks ?? '-'},
  {header: 'New Display Rank', sortKey: 'new_displaygroup_sales_ranks', render: (item) => item.new_displaygroup_sales_ranks ?? '-'},
  {header: 'Changed At', sortKey: 'changed_at', width: 160, render: (item) => renderDashboardDateTwoLine(item.changed_at)},
]

function SalesRankChangesShow() {
  return (
    <DashboardApiTableShow<SalesRankChangeItem>
      endpoint='SalesRankChanges'
      title='Ranking Changes'
      columns={columns}
    />
  )
}

export default SalesRankChangesShow
